import { buttonVariants } from "@/components/ui/button"
import { cn } from "@/lib/utils"
import { Link } from "wouter"

export function Header() {
  return (
    <header data-header className="pointer-events-none fixed inset-x-0 top-6 z-50 px-4 md:px-6 lg:px-6">
      <div data-header-inner className="flex w-full items-center justify-between">
        <div data-header-left className="pointer-events-auto flex items-center">
          <Link
            to="/home"
            className="pointer-events-auto text-3xl font-semibold tracking-tight text-foreground transition-colors hover:text-foreground/70 [font-family:var(--font-display)]"
            aria-label="BC — Home"
          >
            BC
          </Link>
        </div>

        <div data-header-right className="pointer-events-auto hidden items-center justify-center px-3 md:flex md:w-[calc(8rem-0.75rem)] lg:w-[calc(13rem-1.5rem)] lg:px-6">
          <Link
            to="/contact"
            data-header-contact
            className={cn(
              buttonVariants({ variant: "outline", size: "lg" }),
              "group border-foreground/18 bg-transparent px-4 text-foreground/75",
            )}
          >
            Contact
          </Link>
        </div>
      </div>
    </header>
  )
}
